<span class="modal-close-icon"><i class="fa-regular fa-circle-xmark" (click)="closeModal('dismiss')"></i></span>
<div class="modal-body">
  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12">
      <form [formGroup]="relayForm">
        <div class="mt-5">
          <div class="form-row">
            <div class="col-md-4 mb-3">
              <label for="name">Name</label>
              <input type="text" class="form-control" formControlName="name" id="name" placeholder="Name">
            </div>
            <div class="col-md-4 mb-3">
              <label for="relayBoardId">Relay Board</label>
              <select id="relayBoardId" class="form-control" formControlName="relayBoardId">
                <option *ngFor="let relayBoard of relayBoards" [value]="relayBoard.id">
                  {{ relayBoard.name }}
                </option>
              </select>
            </div>
            <div class="col-md-4 mb-3">
              <label for="relayId">Relay ID (1..24)</label>
              <input type="text" min="1" max="24" class="form-control"
                     formControlName="relayId" id="relayId" placeholder="relayId">
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-12 mb-3">
              <label for="description">Description</label>
              <input type="text" class="form-control"
                     formControlName="description" id="description" placeholder="description">
            </div>
          </div>
          <div class="modal-buttons text-center">
            <button type="button" class="btn btn-default add-edit-button" (click)="closeModal(relayForm)">Save</button>
            <button type="button" class="btn btn-light cancel-button" (click)="closeModal('cancel')">Cancel</button>
          </div>
          <div class="form-row mt-4">
            <div class="alert alert-danger" *ngIf="errorMessage">Error: {{errorMessage}}</div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
